module.exports = __webpack_public_path__ + "public/files/img/whatsapp.bc61c4d4.gif";